'use strict';

exports.__esModule = true;
exports.PillBox = exports.STATUSPILL_TONES = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  align-items: center;\n  gap: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  font-size: 12px;\n  font-weight: ', ';\n  line-height: 1;\n  white-space: nowrap;\n  color: ', ';\n  background-color: ', ';\n\n  &::before {\n    content: \'\';\n    width: 7px;\n    height: 7px;\n    border-radius: ', ';\n    background-color: currentColor;\n    flex: none;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  gap: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  font-size: 12px;\n  font-weight: ', ';\n  line-height: 1;\n  white-space: nowrap;\n  color: ', ';\n  background-color: ', ';\n\n  &::before {\n    content: \'\';\n    width: 7px;\n    height: 7px;\n    border-radius: ', ';\n    background-color: currentColor;\n    flex: none;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): Status-Pill-Primitiv (StatusPill).
// Kompakter, runder Status-Badge mit fuehrendem Punkt (::before in currentColor) —
// die zentrale Optik fuer alle Status-Zellen (z.B. ManageStudents: Praktikumsstatus,
// Berichtsheft, Bewertungen). Drei Toene done/open/overdue. Token-Aufloesung mit
// Fallback-Kette analog Card/Alert (greift nur ohne vollstaendigen ThemeProvider).
// Layout (margin, Positionierung in der Zelle) bleibt Konsumenten-Sache via styled(StatusPill).

var STATUSPILL_TONES = exports.STATUSPILL_TONES = { DONE: 'done', OPEN: 'open', OVERDUE: 'overdue' };

// Textfarbe je Ton: done gruen (successColor #2e9e5b), open gedaempftes Grau
// (textColor69 #696969), overdue rot (errorColor #d92b3c). Der fuehrende Punkt erbt
// diese Farbe ueber currentColor.
var resolveColor = function resolveColor(_ref) {
  var theme = _ref.theme,
      tone = _ref.tone;

  switch (tone) {
    case STATUSPILL_TONES.DONE:
      return theme.successColor || '#2e9e5b';
    case STATUSPILL_TONES.OVERDUE:
      return theme.errorColor || '#d92b3c';
    case STATUSPILL_TONES.OPEN:
    default:
      return theme.textColor69 || '#696969';
  }
};

// Fuell-Hintergrund je Ton: done/overdue low-alpha Tint der Tonfarbe (successTint/
// errorTint), open neutrales Hellgrau (grayF3 #F3F3F1).
var resolveBackground = function resolveBackground(_ref2) {
  var theme = _ref2.theme,
      tone = _ref2.tone;

  switch (tone) {
    case STATUSPILL_TONES.DONE:
      return theme.successTint || 'rgba(46, 158, 91, 0.12)';
    case STATUSPILL_TONES.OVERDUE:
      return theme.errorTint || 'rgba(217, 43, 60, 0.10)';
    case STATUSPILL_TONES.OPEN:
    default:
      return theme.grayF3 || '#F3F3F1';
  }
};

var PillBox = exports.PillBox = _styledComponents2.default.span(_templateObject, (0, _spacing.space)(6), (0, _spacing.space)(4, 11), function (_ref3) {
  var theme = _ref3.theme;
  return theme.radiusPill || '999px';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeightUpperBold || 600;
}, resolveColor, resolveBackground, function (_ref5) {
  var theme = _ref5.theme;
  return theme.radiusPill || '999px';
});